module.exports = __webpack_public_path__ + "static/img/committee_banner.d85e93ee.png";